/**
 * Events
 */

import {
  BackStackServiceEventMap,
  ChatServiceEventMap,
  ConfigServiceEventMap,
  LogServiceEventMap,
  PageServiceEventMap,
} from './interfaces';

export interface IMetaOsEventTarget<T = MetaOsEventMaps> {
  addEventListener<K extends keyof T>(type: K, listener: (e: T[K]) => void): void;
  clearListeners(): void;
}

export interface MetaOsEvent {}

export interface MetaOsEventWithData<T> extends MetaOsEvent {
  data: T;
}

/**
 * A helper class Hubs can derive from to implement support for MetaOs Events
 * in MetaOs Services.
 */
export class EventService<T = MetaOsEventMaps> implements IMetaOsEventTarget<T> {
  private registrations: Map<string, (e: any) => void> = new Map<string, (e: any) => void>();

  addEventListener<K extends keyof T>(type: K, listener: (e: T[K]) => void): void {
    this.registrations.set(type, listener);
  }

  dispatchEvent<K extends keyof T>(type: K, e: T[K]): void {
    if (this.registrations.has(type)) {
      this.registrations.get(type)!(e);
    }
  }

  clearListeners(): void {
    this.registrations.clear();
  }
}

export type MetaOsEventMaps =
  | BackStackServiceEventMap
  | ConfigServiceEventMap
  | PageServiceEventMap
  | ChatServiceEventMap
  | LogServiceEventMap;
